export default __webpack_public_path__ + "static/media/actuarial-min.50da38d1.png";